module.exports = __webpack_public_path__ + "static/media/spider-eye.03f932c1.svg";